export enum PreaggregationStrategy
{
    withoutFormula = 1,
    reuploadFile,
    reselectDimensions,
    autoSelectBackDimensions,
    averageAndSum,
}